import { z } from 'zod';

export const contactsStepSchema = z.object({
  ownerPgIds: z.array(z.string()),
  accountContactIds: z.array(z.string()),
});

// Aggregate-only placeholder until the Equipment step's real fields are defined
export const equipmentStepSchema = z.object({
  selectedId: z.string().nullable(),
});

// Aggregate-only placeholder until the Pricing step's real fields are defined
export const pricingStepSchema = z.object({
  lineItems: z.array(z.record(z.string(), z.unknown())),
  customerDeposit: z.object({
    type: z.enum(['percentage', 'flat']),
    amount: z.number(),
  }),
  tradeIns: z.array(z.record(z.string(), z.unknown())),
});

export const financeMenuStepSchema = z.object({});

export const reviewSendStepSchema = z.object({});

export const dealBuilderFormSchema = z.object({
  contacts: contactsStepSchema,
  equipment: equipmentStepSchema,
  pricing: pricingStepSchema,
  financeMenu: financeMenuStepSchema,
  reviewSend: reviewSendStepSchema,
});
